import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UserService } from './services/user.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    constructor(private userService: UserService) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let clonedRequest = null;
        if (this.userService.isAuthenticated()) {
            clonedRequest = request.clone({
                headers: this.createAuthorizationHeader()
            });
        } else {
            clonedRequest = request.clone();
        }
        return next.handle(clonedRequest);
    }

    private createAuthorizationHeader(): HttpHeaders {
        const token = this.userService.user.token;
        const authorization = 'Basic ' + window.btoa(token.replace(' ', ':')).toString();
        const headers = new HttpHeaders();
        return headers.append('Authorization', authorization);
    }
}
